import {
  SearchbarCom,
  SidenavbarCom,
  InputField,
  HoverButton,
} from "../../components";
import { FaPlus } from "react-icons/fa";

import Icons from "../../assets/icon";
import { Controller } from "react-hook-form";
import { IoClose } from "react-icons/io5";
import Functions from "./index.function";
export default function GalleryVideos() {
  const {
    handleSubmit,
    onSubmit,
    register,
    errors,
    videos,
    handleAddVideos,
    handleRemoveVideos,
    control,
    loadingToapi,
    setVideos,
    setValue,
  } = Functions();
  return (
    <div className=" w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>
        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 ">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5`}>
            <div
              className={`flex flex-col relative w-full items-start sm:mt-1.5 scroll-container h-[95vh] sm:h-[90vh] bg-[#1A1A1A] xs:px-2 xs:py-14 sm:px-3 sm:py-16 lg:py-24 lg:px-5 rounded-lg`}
            >
              <div className="w-full">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-4xl font-onestSemiBold text-start">
                  Videos
                </h1>
                <form
                  className="flex justify-center items-center flex-col pt-3 sm:pt-5"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {videos.map((video, index) => (
                    <>
                      {videos.length > 1 && (
                        <div className="flex justify-end w-full items-center">
                          {videos.length > 1 && (
                            <button
                              className="group bg-goldMetallic xs:text-sm xs:w-5 xs:h-5 sm:w-5 sm:h-5 sm:text-xl lg:text-2xl lg:w-7 lg:h-7 rounded-full text-primary flex justify-center items-center transform transition-transform duration-300 hover:scale-110"
                              onClick={() => handleRemoveVideos(index)}
                            >
                              <IoClose className=" transform transition-transform duration-300 group-hover:rotate-180" />
                            </button>
                          )}
                        </div>
                      )}
                      <div key={index} className="mb-6 w-full">
                        <div
                          className={
                            "flex xs:flex-col w-full sm:gap-3 lg:gap-6"
                          }
                        >
                          <div className="relative mt-[18px] w-full">
                            <InputField
                              label="Videos Title"
                              type="text"
                              name={`videos.${index}.title`}
                              control={control}
                              errors={errors}
                              {...register(`videos.${index}.title`, {
                                required: "Videos Title is required",
                              })}
                              value={video.title}
                              onChange={(e) => {
                                const newVideos = [...videos];
                                newVideos[index].title = e.target.value;
                                setVideos(newVideos);
                                setValue(
                                  `videos.${index}.title`,
                                  e.target.value
                                );
                              }}
                            />
                            <div className="flex justify-start items-center xs:pl-6 sm:pl-6 lg:pl-8 xs:pt-[2px] sm:pt-1">
                              {errors?.videos?.[index]?.title && (
                                <span className="text-orangeCrayola text-xs sm:text-sm">
                                  {errors.videos[index].title.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="relative mt-[18px] w-full">
                            <InputField
                              label="Videos External Link"
                              type="text"
                              name={`videos.${index}.link`}
                              control={control}
                              errors={errors}
                              {...register(`videos.${index}.link`, {
                                required: "Videos External Link is required",
                                pattern: {
                                  value:
                                    /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-._~:/?#[\]@!$&'()*+,;=.]+)?$/,
                                  message: "Please enter a valid URL",
                                },
                              })}
                              value={video.link}
                              onChange={(e) => {
                                const newProjects = [...videos];
                                newProjects[index].link = e.target.value;
                                setVideos(newProjects);
                                setValue(
                                  `videos.${index}.link`,
                                  e.target.value
                                );
                              }}
                            />
                            <div className="flex justify-start items-center xs:pl-6 sm:pl-6 lg:pl-8 xs:pt-[2px] sm:pt-1">
                              {errors?.videos?.[index]?.link && (
                                <span className="text-orangeCrayola text-xs sm:text-sm">
                                  {errors.videos[index].link.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="w-full flex justify-start flex-col sm:pt-4">
                          <p className="xs:text-sm sm:text-base font-onestRegular text-secondary">
                            Project Image:
                          </p>
                          <div className="flex items-center gap-x-2 mt-3">
                            <label
                              htmlFor={`projectImg_${index}`}
                              className="bg-[#D9A239] cursor-pointer flex items-center rounded-full px-4 py-2 text-secondary hover:scale-105 hover:bg-[#c59632] transition"
                            >
                              <img
                                src={Icons.uploadProjectIcon}
                                alt=""
                                className="w-4 h-4 mr-2"
                              />
                              Choose File
                            </label>
                            <Controller
                              control={control}
                              name={`videos.${index}.image`}
                              rules={{ required: "Videos Image is required" }}
                              render={({ field }) => (
                                <input
                                  type="file"
                                  accept="image/*"
                                  id={`projectImg_${index}`}
                                  className="hidden"
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (!file) return;

                                    const updatedVideos = [...videos];
                                    updatedVideos[index].image = file;
                                    setVideos(updatedVideos);

                                    field.onChange(file); // updates RHF
                                  }}
                                />
                              )}
                            />
                            {video.image && (
                              <span className="text-white text-xs">
                                {video.image.name}
                              </span>
                            )}
                          </div>
                          <div className="flex justify-start items-center xs:pl-1.5 pl-3 xs:pt-[2px] sm:pt-1">
                            {errors?.videos?.[index]?.image && (
                              <span className="text-orangeCrayola text-xs sm:text-sm">
                                {errors.videos[index].image.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ))}

                  <div
                    onClick={handleAddVideos}
                    className="bg-[#D9A239] cursor-pointer flex items-center gap-x-2 text-secondary text-sm rounded-full px-4 py-2 hover:scale-105 hover:bg-[#c59632] transition"
                  >
                    <FaPlus className="text-lg" />
                    Add Another Video
                  </div>
                  <div className="flex justify-center flex-col items-center my-10 lg:my-8">
                    <HoverButton
                      extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform ${
                        loadingToapi
                          ? ""
                          : "cursor-pointer hover:scale-105 hover:shadow-md"
                      } `}
                      BtnTitle={
                        loadingToapi ? (
                          <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                          </div>
                        ) : (
                          "Submit"
                        )
                      }
                      disabled={loadingToapi}
                      type={"submit"}
                      BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                        loadingToapi
                          ? ""
                          : "group-hover:scale-110 group-hover:text-primary"
                      } `}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
